/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */

/*
<div class="form-group pb-3">
    <label for="${name}" class="pb-2 fs-4">${title}</label>
    <div class="input-group">
        <div class="input-group-prepend">
            <div class="input-group-text rounded-0 rounded-start input-icon-block"><i class="${icon}"></i></div>
        </div><input id="${name}" class="form-control is-invalid" title="${title}">
    </div>
</div>
*/
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.doc.simple",
  title: "Simple Document",
  description: "A simple document with formatting controls. Replaces the textarea.",
  control: true,
  preview: "ua.preview.doc",
  prevalidate: true,
  supportServer: false,
  build: {
    copy: {
      from: "@!/node_modules/quill/dist/",
      to: "@!/app/build/quill/"
    }
  },
  fields: {
    "name": {
      title: "Name",
      type: "string",
      description: "The name of the control.",
      required: true
    },
    "title": {
      title: "Title",
      type: "string",
      description: "The title of the control.",
      required: true
    },
    "description": {
      title: "Description",
      type: "inner",
      description: "The help text or description of the item.",
    },
    "formats": {
      title: "Formating",
      type: "list",
      of: "string",
      description: "The formatting to support in this instance.",
      list: {
        must: ["background", "bold", "color", "font", "code", "italic", "link", "size", "strike", "script", "underline", "blockquote", "header", "indent", 
          "list", "align", "direction", "code-block", "image", "video"
        ]
      },
      default:  ["bold", "italic", "underline", "list"],
      addtouae: true
    },
    "theme": {
      title: "Theme",
      type: "string",
      description: "The theme of the document editor.",
      default: "snow",
      list: {
        must: ["snow", "bubble"]
      },
      addtouae: true
    },
    "value": {
      title: "Value",
      type: ["string", "inner"],
      description: "The inner or html value of the control"
    }, "inputClass": {
      title: "Input Class",
      type: "string",
      description: "The class of the input."
    }, "inputStyle": {
      title: "Input Style",
      type: "string",
      description: "The style of the input."
    }, "description": {
      title: "Description",
      type: "inner",
      description: "The helpful text to display above the document."
    }, "required": {
      title: "Required",
      type: "boolean",
      description: "If the field is required to be filled out.",
      default: false,
      addtouae: true
    }, "minlength": {
      title: "Minimum Length",
      type: "number",
      description: "The minimum length of the text in the document.",
      default: 0,
      addtouae: true
    }, "maxlength": {
      title: "Maximum Length",
      type: "number",
      description: "The maximum length of the text in the document.",
      default: 0,
      addtouae: true
    }
  },
  passthrough: {
    except: ["inner", "type", "id", "inputclass", "inputstyle"]
  }, 
  external: {
    name: "Quill Editor",
    src: "@!/build/quill/quill.js",
    type: "text/javascript"
  }
});

var events = require("../../../uam/events.js");
var isServer = require("../../../uam/functions/isServer.js").function();

// var Quill = false;
// if (isServer) {
//   //server side quill is not a thing
// } else {
//   Quill = window.UATools.quill.Quill;
// }

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");

var themes = {
  "snow": {
    "css": "@!/build/quill/quill.snow.css",
    "loaded": false
  },
  "bubble": {
    "css": "@!/build/quill/quill.bubble.css",
    "loaded": false
  }
}
 
/**
 * Preparing migration to jsonRender and uae.render();
 * @param {*} options The object to render
 * @returns a ua.code dom element
 */
exports.render = async function (options) {

  var randomName = uai.generateRandomID(24);

  var texteditor = {
    "n": "div",
    "id": randomName,
    "class": "ua-doc-simple",
    "title": options.title
  };

  if ("value" in options) {
    texteditor.value = options.value;
  }

  try {
    // console.log("*** Opt 1", {
    //   options, _input});

    texteditor = jsonRender.pass({...options}, {...texteditor}, ["name", "class", "icon", "style"]);

      // console.log("My new input", myNewInput);

    // _input = await jsonRender.pass(options, _input, ["name", "class", "icon", "style"]);
  } catch (error) {
    // console.log(`ua.input Error: ${error}`);
  }

// console.log("*** Opt 2", JSON.stringify([options, _input], null, 2));

  // console.log("Input", {input, options});

  if ("inputclass" in options) {
    texteditor.class += " " + options.inputclass;
  }

  // console.log("*** Opt 3", JSON.stringify([options, _input], null, 2));

  if ("inputstyle" in options) {
    texteditor.style = options.inputstyle;
  }

//   console.log("*** Opt 4", JSON.stringify([options, _input], null, 2));

// console.log("*** Opt 5", JSON.stringify([options, _input], null, 2));


  var element = {
    "n": "div",
    "name": options.name,
    "c": "form-group pb-3",
    "i": [{
      "n": "label",
      "for": randomName,
      "c": "pb-2 fs-4",
      "i": options.title
    }, {
      "n": "div",
      "c": "ua-doc-simple-h",
      "i": texteditor
    }]
  }

  // console.log("*** Opt 6", JSON.stringify([options, _input], null, 2));

  //if icon is provided
  // if ("icon" in options) {
  //   element.i[1].i= [{
  //     "n": "div",
  //     "c": "input-group-prepend",
  //     "i": [{
  //       "n": "div",
  //       "c": "input-group-text rounded-0 rounded-start input-icon-block",
  //       "i": [{
  //         "n": "i",
  //         "class": options.icon
  //       }]
  //     }]
  //   }];
  // } else {
  //   element.i[1].i = texteditor;
  // }

  //add <div id="passwordHelpBlock" class="form-text">${options.description}</div>/*
  if ("description" in options) {
    element.i.push({
      "n": "div",
      "id": `${randomName}-description`,
      "c": "form-text",
      "i": options.description
    });
  }

  // element.i[1].i.push(texteditor);

  //check if the format is loaded
  if (options.theme in themes && !(themes[options.theme].loaded)) {
    //load the css
    var css = document.createElement("link");
    css.setAttribute("rel", "stylesheet");
    css.setAttribute("href", uai.resolveURL(themes[options.theme].css));
    document.head.appendChild(css);
    themes[options.theme].loaded = true;
  }

  //bubble iup changes from the input to the element

  // texteditor.addEventListener("change", function (event) {
  //   var changeEvent = new Event("change");
  //   element.dispatchEvent(changeEvent);
  // });

  return element;
  
  // console.log("*** Opt 7", {options, _input});

  // console.log("ua.input Sending an element", JSON.stringify([element, options], null, 2));

  var domElement = await jsonRender.render(element);

  // console.log("The Dom Element", domElement);

  var input = domElement.querySelector("input");

  // var focusFunction = (event) => {
  //   var uaeElement = this.closest("uae");
  //   // console.info(
  //   //     "Radio Group Change",
  //   //     { uaeElement }
  //   // );
  //   save(options.name, uaeElement, {});
  // }

  // console.log("The Input", input);

  input.addEventListener("change", function (event) {
    //get the uae element plceholder
    var uaeElement = this.closest("uae");
    // console.info(
    //     "Radio Group Change",
    //     { uaeElement }
    // );
    save(options.name, uaeElement, {});
  });

  // input.addEventListener("change", focusFunction);
  // input.addEventListener("focusout", focusFunction);

  // console.log("*** Opt 9", options);

  return domElement;

}

/**
 * Hold processing until quill is loaded.
 * @returns {Promise} A promise that resolves when Quill is loaded.
 */
async function UntilQullIsLoaded() {

  //check if Quill variable is defined
  if (typeof Quill === "undefined") {
    //wait for 100ms and try again
    await new Promise(resolve => setTimeout(resolve, 100));
    return UntilQullIsLoaded();
  }

  return true;

}

var isLoading = false;

events.on("interface.afterrender", async function() {

  if (isLoading) {return};

  isLoading = true;

  //get all uae elements where namespace = _.namespace and not rendered=true
  var elements = document.querySelectorAll(`uae[namespace="${_.namespace}"]`);
  
  for (var i = 0; i < elements.length; i++) {

    let element = elements[i];

    //is their a quill mounted
    if (element.quill) {
      continue;
    }

    await UntilQullIsLoaded();

    var editorDiv = element.querySelector(".ua-doc-simple");
    var theme = _.define.fields.theme.default;

    //if the element has the attribute theme
    if (element.hasAttribute("theme")) {
      theme = element.getAttribute("theme");
    }

    var formats = _.define.fields.formats.default;

    //if the element has the attribute formats
    if (element.hasAttribute("formats")) {
      formats = JSON.parse(element.getAttribute("formats").split(","));
    }

    var quill = new Quill(editorDiv, {
      theme: theme,
      formats: formats,
      modules: {
        toolbar: formats
      }
    });

    //attached the quill to the element
    element.quill = quill;

    var setTimeoutVar = null;
    //if the quill input has changed dispatch the event on the element
    quill.on("text-change", function(delta, oldDelta, source) {
      //buonce every 1 second
      clearTimeout(setTimeoutVar);
      setTimeoutVar = setTimeout(() => {
        // console.log(`quill: Dispatching change event for ${element.getAttribute("name")}`);
        // var changeEvent = new Event("change");
      // element.dispatchEvent(changeEvent);
        element.dispatchEvent(new Event("change"));
      }, 1000);

    });

    // //if the element is clicked and the quill editor is not focused, focus the quil editor
    // editorDiv.addEventListener("click", function(event) {

    //   console.log("Focusing the quill editor");

    //   // console.log("Editor Div Clicked", this);
    //   //if the quill editor is not focused

    //   if (this.quill && this.quill.root && !this.quill.hasFocus()) {
    //     //focus the quill editor
    //     this.quill.focus();
    //     console.log("Focusing the quill editor");
    //   }
    // });


    //set the rendered attribute to true
    // element.setAttribute("rendered", "true");
  }

  isLoading = false;

});

// async function focus(event) {
//   // console.log("focus", event);


//   //get the parent uae element
//   var parent = this.closest("uae");

//     this.classList.remove("is-invalid");
//     this.classList.remove("is-valid");

//     //if the input is not empty
//     if (this.value.trim() != "") {
     
//       if (validation(parent).length > 0) {
//         parent.classList.add("is-invalid");
//         this.classList.add("is-invalid");
//       } else {
//         parent.classList.add("is-valid");
//         this.classList.add("is-valid");
//       }

//     }
// }


function validation(control, name) {
  // var input = control.querySelector("input");
  var errors = [];

  //reset the style
  control.classList.remove("is-invalid");
  control.classList.remove("is-valid");

  //get the quil editoer
  var quill = control.quill;
  
  var myText = quill.getText().trim();

  //is the required attribute set on the control
  if (control.hasAttribute("required") && control.getAttribute("required") == "true") {
    //if the quill editor has no content

    //if the quill editor has no content
    if (myText == "") {
      // repo.success = false;
      errors.push({
        type: "validation",
        message: "This field is required. An empty line will be conisdered as no text.",
        input: {
          id: name,
          name: name
        }
      });
    }

  }

  //test uae[minlength] and uae[maxlength]
  if (control.hasAttribute("minlength")) {
    var minlength = parseInt(control.getAttribute("minlength"));
    //if it's 0 ignore it
    if (minlength > 0 && myText.length < minlength) {
      errors.push({
        type: "validation",
        message: `This field must be at least ${minlength} characters long.`,
        input: {
          id: name,
          name: name
        }
      });
    }
  }

  if (control.hasAttribute("maxlength")) {
    var maxlength = parseInt(control.getAttribute("maxlength"));
    //if it's 0 ignore it
    if (maxlength > 0 && myText.length > maxlength) {
      errors.push({
        type: "validation",
        message: `This field must be at most ${maxlength} characters long.`,
        input: {
          id: name,
          name: name
        }
      });
    }
  }

  // if (!(input.checkValidity())) {
  //   // console.log("Input invalid", input.validationMessage);
  //   errors.push({
  //     type: "validation",
  //     message: input.validationMessage
  //   });
  // }

  return errors;
}


/**
 * Saves the code from the iframe.
 * Called by UATools.
 * @param {*} name The name of the control.
 * @param {*} control The control to save.
 * @param {*} repo The repo (used to send back), with the prevalidation results.
 * @property {*} repo.success The success object (is this field ready to be saved).
 * @property {*} repo.data The actual data object that will be saved. JSON encodable only (no functions or promises).
 * @property {*} repo.errors The error's applied to the object. Should be an array, can have more than one item.
 * @property {*} repo.errors.input If appliable, the direct input that caused the erorr - it must be an object. If input is not provided the control will be highlighted.
 * @property {*} repo.errors.input.id The id of the input field, if applicable.
 * @property {*} repo.errors.input.name The name of the input field if applicable.
 * @property {*} repo.errors.type The type of error that occured.
 *  - Supports: "validation" - The input or field or control is invalid
 *  - Supports: "thowable" - Processing this field caused a throwable to error out.
 * @property {*} repo.errors.message The message to display to the user.
 * @returns The repo object with the data to save
 */
async function save(name, control, repo) {

  // console.log("Starting save", {
  //   control, repo
  // });


  //get the input from the control and check if it's valid
  // var input = control.querySelector("input");

  
  var quill = control.quill;

  repo.errors = validation(control, name);
  if (repo.errors.length > 0) {
    repo.success = false;
    control.classList.add("is-invalid");
  } else {
    repo.success = true;
    control.classList.add("is-valid");
  } 



  repo.data = quill.getSemanticHTML();
  repo.data = await jsonRender.convertHTML(repo.data);

  // console.log("Ending save", {
  //   control, repo
  // });

  return repo;

} module.exports.save = save;

/**
 * Loads the control with data.
 * @param {*} name The name of the control.
 * @param {*} control The control itself (including placeholder tag).
 * @param {*} data The data to load into the control.
 */
async function load(name, control, data) {

  //get the input from the control
  var input = control.querySelector("input");

  //ensure that I won't update the control if the data is empty and it's already empty
  //if the data is null or undefined and the input is empty
  if (!(data) || data == "" && input.value == "") {
    return;
  }

  var quill = control.quill;

  //clear the quill editor
  quill.setText("");

  //set the quill editor to the data
  //if the data is a string it must be embedded HTML if its an object it needs converted

  if (typeof data === "string") {
    //if the data is a string, set the quill editor to the HTML
    quill.clipboard.dangerouslyPasteHTML(data);
  } else if (typeof data === "object") {
    //if the data is an object, convert it to HTML
    var html = await jsonRender.render(data);
    var ele = document.createElement("div");
    ele.appendChild(html);
    html = ele.innerHTML;
    quill.clipboard.dangerouslyPasteHTML(html);
  }

  //set the value
  // input.value = data;

} module.exports.load = load;